import { getUserProfile } from "./../../api/endpoints/auth/getUserProfile";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class AuthMixin extends Vue {
  /**
   * 获取用户信息
   * @returns
   */
  async getUserProfile(role?: boolean): Promise<any> {
    try {
      return await getUserProfile(role);
    } catch (err) {
      console.log(err);
    }
  }

  async resolveUserStatus(_p = null) {
    let profile;
    if (!_p) profile = await this.getUserProfile(true);
    else profile = _p;
    if (profile.id) {
      // 已登录
      if (!profile.password) {
        // 需要重置密码
        this.$router.push({ name: "initUserPassword" });
        return;
      }
      if (!profile.phone_number) {
        // 需要绑定手机号
        this.$router.push({ name: "initUserPhoneNumber" });
        return;
      }

      const { role } = this.$route.query;
      // 否则， 需要重定向
      if (this.$route.query.from) {
        window.location.href = `${this.$route.query.from}`;
      }
      if (role === "admin") {
        if (profile.roles.some((role: any) => role.id == 1)) {
          this.$router.push({ name: "admin_page" });
          return;
        }
      }
      if (role === "leader") {
        if (profile.roles.some((role: any) => role.id == 2)) {
          this.$router.push({ name: "leader_page" });
          return;
        }
      }
      if (role === "member") {
        if (profile.roles.some((role: any) => role.id == 3)) {
          this.$router.push({ name: "member_page" });
          return;
        }
      }
      this.$router.push({ name: "userProfile" });
    } else {
      // 没有登录
      if (this.$route.name !== "auth" && this.$route.name !== "login")
        this.$router.push({ name: "auth" });
    }
  }
}
